import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import HistoryIcon from "@mui/icons-material/History";
import LogoutIcon from "@mui/icons-material/Logout";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ViewCarouselIcon from '@mui/icons-material/ViewCarousel';
import { Box, Divider, IconButton } from "@mui/material";
import Fade from "@mui/material/Fade";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import * as React from "react";
import { useNavigate } from "react-router-dom";
import { sessions } from "../localstorage/SessionStorage";

const pages = [
  {
    name: "Dates Configuration",
    url: "application-dates",
    icon: <CalendarMonthIcon />,
  },
  { name: "Decline Reasons", url: "decline-reasons", icon: <HistoryIcon /> },
  { name: "Setup Home Page Banner", url: "banner", icon: <ViewCarouselIcon /> },
  
];

export default function SettingsMenu() {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const navigate = useNavigate();
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (e:any, url: string) => {
    setAnchorEl(null);
    if(url && url !== 'backdropClick')
      navigate(`/${url}`);
  };

  return (
    <div>
      <IconButton
        id="fade-button"
        aria-controls={open ? "fade-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        sx={{ color: "white" }}
      >
        <MoreVertIcon />
      </IconButton>

      <Menu
        id="fade-menu"
        MenuListProps={{
          "aria-labelledby": "fade-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
      >
        {pages.map((page, key: React.Key) => {
          return (
            <MenuItem key={key} onClick={(e) => handleClose(e,page.url)}>
              {page.icon}{" "}
              <Box component="span" ml={2}>
                {page.name}
              </Box>
            </MenuItem>
          );
        })}
        <Divider />
        {sessions.getToken() && (
          <MenuItem
            onClick={() => {
              sessions.removeToken();
              navigate("/");
              window.location.reload();
            }}
          >
            <LogoutIcon />
            <Box component="span" ml={2}>
              Logout
            </Box>
          </MenuItem>
        )}
      </Menu>
    </div>
  );
}
